<template>
    <div>
        <div class="w-full">
            <label :for="firstnameKey">{{ firstnameLabel }}</label>
            <div class="flex justify-between align-center gap-1">
                <input @input="updateParentValue" v-model.trim="firstname" class="input-styling" v-focus ref="textInput"  type="text" :placeholder="firstnamePlaceholder">
                <label :for="lastnameKey">{{ lastnameLabel }}</label>
                <input @input="updateParentValue" v-model.trim="lastname" class="input-styling" type="text" :placeholder="lastnamePlaceholder">
            </div> 
        </div>
        <div class="error-text-styling">
            <div v-if="displayErrorMessage">
                {{step.errorMessage}}
            </div>
        </div>
    </div>
</template>

<script>
import { minLength, required } from 'vuelidate/lib/validators';


export default {
    props: ['step'],
    data() {
        return {
            firstname: '',
            lastname: '',
            firstnameKey: this.step.name,
            firstnameLabel: this.step.label,
            firstnamePlaceholder: this.step.placeholder,
            lastnameKey: this.step.name2,
            lastnameLabel: this.step.label2,
            lastnamePlaceholder: this.step.placeholder2,
            firstnameDirty: false,
            lastnameDirty: false
        }
    },
    validations: {
        firstname: {
            required,
            minLength: minLength(1)
        },
        lastname: {
            required,
            minLength: minLength(1)
        }
    },
    computed: {
        firstnameValid() {
            return !this.$v.firstname.$invalid;
        },
        lastnameValid() {
            return !this.$v.lastname.$invalid;
        },
        inputValid() {
            return this.firstnameValid && this.lastnameValid;
        },
        displayErrorMessage() {
            this.$emit('error')
            return !this.inputValid && this.firstnameDirty && this.lastnameDirty;
        }
    },
    watch: {
        firstname(){
            this.firstnameDirty = true;
        },
        lastname(){
            this.lastnameDirty = true;
        }
    },
    methods: {
        updateParentValue(e){
            this.$emit("input", {'value': this.firstname + ' ' + this.lastname, 'valid': this.firstnameValid && this.lastnameValid})
            
        }
    }
}
</script>

<style lang="scss" scoped>




.double-input {
    max-width: 284px;
    margin: 0 5px;
}
</style>
